var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "header-container" },
    _vm._l(_vm.headers, function(header) {
      return _c(
        "div",
        {
          key: header.label,
          staticClass: "header",
          style: { width: header.width }
        },
        [
          _c("span", { staticClass: "header-label" }, [
            _vm._v(_vm._s(header.label))
          ]),
          _vm._v(" "),
          header.value === "type"
            ? _c("span", { staticClass: "header-value" }, [
                _vm._v("\n      " + _vm._s(_vm.objectType) + "\n    ")
              ])
            : header.value === "nrCables"
            ? _c(
                "span",
                {
                  staticClass: "header-value",
                  staticStyle: { "text-align": "right" }
                },
                [_vm._v("\n      " + _vm._s(_vm.nrCables) + "\n    ")]
              )
            : header.value === "nrTubes"
            ? _c(
                "span",
                {
                  staticClass: "header-value",
                  staticStyle: { "text-align": "right" }
                },
                [_vm._v("\n      " + _vm._s(_vm.nrTubes) + "\n    ")]
              )
            : header.value === "material"
            ? _c("span", { staticClass: "header-value" }, [
                _vm._v(
                  "\n      " +
                    _vm._s(
                      _vm.objectPrefix === "mb"
                        ? _vm.objectMaterialDescription
                        : "-"
                    ) +
                    "\n    "
                )
              ])
            : _vm.objectPrefix === "mb"
            ? _c("span", { staticClass: "header-value" }, [
                _vm._v(
                  "\n      " +
                    _vm._s(
                      _vm.conductData.microducts_bundles[0][
                        _vm.objectPrefix + "_" + header.value
                      ]
                        ? _vm.conductData.microducts_bundles[0][
                            _vm.objectPrefix + "_" + header.value
                          ]
                        : "-"
                    ) +
                    "\n    "
                )
              ])
            : _c("span", { staticClass: "header-value" }, [
                _vm._v(
                  "\n      " +
                    _vm._s(
                      _vm.conductData[_vm.objectPrefix + "_" + header.value]
                        ? _vm.conductData[_vm.objectPrefix + "_" + header.value]
                        : "-"
                    ) +
                    "\n    "
                )
              ])
        ]
      )
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4a2f706c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4a2f706c","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Home/Forms/_SpecialTabs/Pathways/MicroDuctPanelHeader.vue
// module id = null
// module chunks = 